import {FirebaseApp} from "@/plugins/Firebase";
import {getDownloadURL, getStorage, ref} from "firebase/storage";

const Storage = getStorage(FirebaseApp);
const getStorageRef = ref.bind(this, Storage);

export {Storage, getStorageRef, getDownloadURL};
